import { render, staticRenderFns } from "./StarDesigner.vue?vue&type=template&id=5ac3bb6d&scoped=true&"
import script from "./StarDesigner.vue?vue&type=script&lang=js&"
export * from "./StarDesigner.vue?vue&type=script&lang=js&"
import style0 from "./StarDesigner.vue?vue&type=style&index=0&id=5ac3bb6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac3bb6d",
  null
  
)

export default component.exports